import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectTheme } from '../../app-state/slices/ThemeSlice';

export const usePartnerPreferences = (): [
    { [k: string]: any },
    (locale?: string) => { value: string; label: string } | undefined
] => {
    const { preference: partnerPreference } = useSelector(selectTheme);

    const getLanguage = useCallback(
        (locale?: string) => {
            return partnerPreference?.data?.supportedLocales?.find(
                (item: any) => item?.value === locale
            );
        },
        [partnerPreference?.data?.supportedLocales]
    );

    return [partnerPreference?.data, getLanguage];
};
